<template>
  <div class="container">
    <HeadInfo></HeadInfo>

    <div class="listSty">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        :offset="2"
        @load="onLoad"
      >
        <div class="outline" v-for="(item, index) in perInfoList" :key="index">
          <div class="headSty">
            <div>
              {{ index === 0 ? "上周概要" : "时长概要" }}（{{
                filterTime(item.week_start) || ""
              }}-{{ filterTime(item.week_end) || "" }} ）
            </div>
            <div class="look" @click="toDetails(item)">详情 ></div>
          </div>
          <div class="content">
            <div class="flexSty bianju">
              <div>总学习时长：</div>
              <div>{{ item.ddj_study_time }}分钟</div>
            </div>
            <div class="flexSty">
              <div>总娱乐时长：</div>
              <div>{{ item.time }}分钟</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { List } from "vant";
import HeadInfo from "./components/HeadInfo.vue";
import { entertainmenttimehistory } from "@/api/squirrelCup";

export default {
  data() {
    return {
      perInfo: {},
      perInfoList: [],

      loading: false,
      finished: false,
      total: 40,
      page: {
        pageIndex: 0,
        pageSize: 10,
      },
    };
  },
  components: {
    [List.name]: List,
    HeadInfo,
  },
  mounted() {
    this.perInfo = JSON.parse(localStorage.getItem("headInfo"));
    this.onLoad();
  },
  methods: {
    getLoadLIst() {
      this.loading = true;
      const postData = {
        ...this.page,

        param: {
          account_id: Number(this.perInfo.accountId),
        },
      };
      entertainmenttimehistory(postData).then((res) => {
        console.log(res);
        this.total = res.data.count;
        this.perInfoList = this.perInfoList.concat(res.data.reports);
        this.loading = false;
        if (this.perInfoList.length >= this.total)
          return (this.finished = true);
      });
    },
    filterTime(value) {
      console.log(value);
      let dateString = String(value) || "20240506";
      let year = dateString?.substring(0, 4);
      let month = dateString?.substring(4, 6);
      let day = dateString?.substring(6, 8);
      return `${month}.${day}`;
    },
    onLoad() {
      this.page.pageIndex++;
      this.getLoadLIst();
    },
    toDetails(info) {
      this.$router.push({
        path: "/winterGame/weekly/details",
        query: {
          week_start: info.week_start,
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.container {
  margin: 40px 32px 0 32px;
  overflow: hidden;
  .outline {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 48px;
    .headSty {
      display: flex;
      justify-content: space-between;
      margin-top: 48px;
      margin-bottom: 16px;
      .look {
        font-weight: 400;
        font-size: 28px;
        color: #58abf6;
      }
    }
    .content {
      position: relative;
      background: #9997978b;
      font-weight: 400;
      color: #323232;
      padding: 32px 64px;
      background: #f6f9fd;
      border-radius: 16px;
      .flexSty {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .listSty {
    height: calc(100vh - 200px);
    overflow: auto;
  }
  .bianju{
    margin-bottom: 12px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
